/**
* Sem tratativa.
*/
const NONE = 0;

/**
* Visto.
*/
const SEEN = 1;

/**
* Descartado.
*/
const DISMISSED = 2;
/**
* Em quarentena.
*/
const QUARENTINE = 3;
/**
* Relatório anexado.
*/
const REPORT_ATTACHED = 4;
/**
*  Quarentena expirada. Não ocorre no banco de dados, existente apenas para envio para o front-end.
*/
const EXPIRED_QUARENTINE = 5;

export default {
	NONE,
	SEEN,
	DISMISSED,
	QUARENTINE,
	REPORT_ATTACHED,
	EXPIRED_QUARENTINE
};